import { i18n } from 'config/i18n'
import { ApiErrorServer } from 'interfaces/api.interfaces'
import { ApiError, ApiTypingErrors } from 'packages/api'

export enum ApiErrorsCodes {
  NotFound = 'not_found',
  NotValid = 'not_valid',
  UnknownError = 'unknown_error',
}

export const apiTypingErrors = new ApiTypingErrors<ApiError, ApiErrorServer>({
  notValidStatus: 400,
  initialError: () => ({
    message: i18n.get('apiErrors.unknownError'),
    code: ApiErrorsCodes.UnknownError,
  }),
  notFoundError: () => ({
    message: i18n.get('apiErrors.notFound'),
    code: ApiErrorsCodes.NotFound,
  }),
  notValidError: () => ({
    message: i18n.get('apiErrors.notValid'),
    code: ApiErrorsCodes.NotValid,
  }),
  validationReplaceToCamelCase: true,
  getMessageErrorApi: (responseError) =>
    responseError?.data?.detail ??
    responseError?.data?.msg ??
    responseError?.data?.error?.detail ??
    (typeof responseError?.data?.error === 'object' ? responseError?.data?.error?.msg : undefined) ??
    responseError?.data?.file?.[0],
})

export const { errorInterceptor, createApiError } = apiTypingErrors
